import { atom } from 'jotai';

import { logger } from '@service-initiation/shared-clients-osp-logger';
import { getDeviceColorOptions } from '@service-initiation/tech-care-data-access-tech-care-services';

import { type DeviceDetails } from '../types';
import { deviceDetailsAsyncAtom } from './deviceDetailsAsyncAtom';

const getDeviceColorOptionsWithErrorHandling = async (
  device: DeviceDetails
) => {
  try {
    if (device.isEligibleForColorOptions) {
      return await getDeviceColorOptions(device);
    }
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to hydrate device color options';
    logger.error(err, {
      data: { device },
    });
  }
};

export const deviceColorOptionIdsAsyncAtom = atom(async (get) => {
  const deviceDetails = await get(deviceDetailsAsyncAtom);

  const colorOptions = deviceDetails
    ? await getDeviceColorOptionsWithErrorHandling(deviceDetails)
    : undefined;

  return colorOptions;
});
